import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface Props {
  label: string;
  icon?: IconProp;
  onClick?: () => void;
}

const Button = ({ label, icon, onClick }: Props) => {
  return (
    <div
      className="px-3 py-1 rounded-full border-primary border text-primary space-x-2 cursor-pointer flex items-center justify-center"
      onClick={onClick}
    >
      {icon && <FontAwesomeIcon icon={icon} />}
      <div className="">{label}</div>
    </div>
  );
};

export default Button;
